import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { AltraParte } from 'src/app/common/models/altraparte';
import { Parte } from 'src/app/common/models/parte';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { SearchAnagraficheResponse } from 'src/app/common/models/dto/search-anagrafiche-response';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { TipoPersona } from 'src/app/common/models/tipologiche/tipo-persona';
import { SearchTextComponent } from 'src/app/common/components/input-component/searchText/search-text.component';
import { filterElaborationEntity, filterElaborationEntityClean, getMockEntity, isNumeric } from '../../utils/wizard-utils';
import { ElaborationEntityConstants } from '../../constants/elaboration-entity-constants';
import { extractParteEntityFromSearch, isDuplicate, isParteAssociable, parteFromEntity, setTempId } from '../../utils/parti-utils';
import { isAltraparteAssociated } from '../../utils/altraparte-utils';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { Subject, combineLatest, concat } from 'rxjs';
import { distinctUntilChanged, filter, skipWhile, take, takeUntil, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { stepMap } from '../creazione-pratica-stepper/config/step';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { DocumentoAddModal } from 'src/app/common/components/documenti/documento-add/documento-add-modal.component';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { DocumentVersionHistoryModal } from 'src/app/common/components/documenti/documento-history-version/document-version-history-modal.component';
import { DocumentUpdateMetadatiModal } from 'src/app/common/components/documenti/documento-update-metadati/document-update-metadati-modal.component';
import { DocumentVersionUpdateModal } from 'src/app/common/components/documenti/documento-version-update/document-version-update-modal.component';
import { UpdateMetadatiComponent } from 'src/app/common/components/fascicolo/documentazione-allegata-view/metadati/update-metadati/update-metadati.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';

declare var closeModal: any;
@Component({
  selector: 'step-soggetti-terzi',
  templateUrl: './step-soggetti-terzi.component.html',
  styleUrls: ['./step-soggetti-terzi.component.css']
})
export class StepSoggettiTerziComponent implements OnInit, OnDestroy {
  requestSearchUrl = ServicePathsSettings.URL_SEARCH_PARTE;
  foundElements: { isAssociable: boolean, isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte }[] = [];
  suggeritiFound: { isAssociable: boolean, isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte, categoria?: string, tipoSoggetto?: string }[] = [];
  altreParti: AltraParte[] = [];
  altrePartiTmp: AltraParte = null;
  activeTab = 0;
  parte: Parte = null;
  parteTmp: Parte = null;
  entitiesFiltered: ElaborationDocumentFilterEntity[] = [];
  action: string;
  tipoPersonaOptions: TipoPersona[] = [];
  hasSearched: boolean = false;
  searchText: string = null;
  totalResults = 0;
  isConcatSearch: boolean = false;
  waitResponseSearch: boolean = false;
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>();
  count = 0;
  sezione = null;
  fascicolo = null;
  componentDestroyed$: Subject<void> = new Subject<void>();
  accordions = stepMap;
  @ViewChild('searchElement') searchElement: SearchTextComponent;
  @ViewChild('docAddModalAltreParti') docAddModalAltreParti: DocumentoAddModal;
  @ViewChild('docVersionHistoryAltreParti') docVersionHistoryAltreParti: DocumentVersionHistoryModal;
  @ViewChild('docVersionUpdateModalAltreParti') docVersionUpdateModalAltreParti: DocumentVersionUpdateModal;
  
  constructor(private operations: OperationsService,
    private viewManager: ViewManagerService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private tipologicheService: CreazionePraticaTipologicheService,
    private router: Router,
    private dialog: DialogService
  ) { 
      this.creazionePraticaStoreService._docAdd.subscribe(
        data => {
          if(data?.tipoSezione?.descrizione === "ALTRE PARTI") {
              if(!!this.sezione) {
                this.sezione.documentiAggregati = data.documentiAggregati
                this.altreParti = [...data.altreParti];
                this.creazionePraticaStoreService.setSoggettiTerzi(data.altreParti);
                this.creazionePraticaStoreService.save();
              }
            
          }
        }
      )
    }

  ngOnInit() {
    this.count = 0;
    this.totalResults= 0;
    this.suggeritiFound = [];
    this.foundElements = [];
    this.entitiesFiltered = [];
    this.viewManager.initializeBody();
    this.readSezione();
    this.creazionePraticaStoreService.soggettoTerzo$.subscribe(altreParti => {
      if (altreParti && altreParti.length > 0) {
        this.altreParti = altreParti;
      } else {
        this.altreParti = []
      }
      this.checkParteisAltraparte();
    })


    const soggettiTerziSuggestedStored$ = this.creazionePraticaStoreService.suggestedSoggettiTerzi$.pipe(
      take(1),
      filter(suggested => suggested.length > 0),
      tap(suggested => this.suggeritiFound = suggested),
    );

    const entitiesAndTipiPersona$ = combineLatest(
      this.creazionePraticaStoreService.entities$.pipe(
        distinctUntilChanged(),
        filter(entities => entities.length > 0),
        tap(entities => {
          this.entitiesFiltered = filterElaborationEntityClean(entities, [ElaborationEntityConstants.LEGAL_PRINCIPAL_ACTOR,
          ElaborationEntityConstants.LEGAL_DEFENDANT,
          ElaborationEntityConstants.OTHER_COUNTER_PARTS]);
        })

      ),
      this.tipologicheService.getTipiPersona().pipe(
        distinctUntilChanged(),
        tap(tipoPersonaOptions => this.tipoPersonaOptions = tipoPersonaOptions)
      )
    ).pipe(take(1));


    concat(soggettiTerziSuggestedStored$, entitiesAndTipiPersona$).pipe(
      takeUntil(this.componentDestroyed$),
      skipWhile(() => this.suggeritiFound.length > 0),
    ).subscribe(() => this.getSuggeriti());
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.creazionePraticaStoreService.setSoggettiTerzi(null);
    this.creazionePraticaStoreService.save();
  }

  private getSuggeriti() {
    if (this.entitiesFiltered && this.entitiesFiltered.length > 0 && this.tipoPersonaOptions && this.tipoPersonaOptions.length > 0) {
      if (this.router.url.endsWith('consultazione')) {//logica per il wizard di consultazione
        let outputArray: ElaborationDocumentFilterEntity[] = [];
        this.entitiesFiltered.forEach(obj => {
          let cleanedValore = obj.valore.replace(/nome:|cognome:|ragioneSociale:/g, "").trim();
          let formattedObj = Object.assign({}, obj);
          formattedObj.valore = cleanedValore;
          outputArray.push(formattedObj);
        });
        outputArray.forEach(element => this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore.substring(0, element.valore.indexOf(" categoria") != -1 ? element.valore.indexOf(" categoria") : element.valore.length - 1), fromResult: 0 }).subscribe(response => {
          let filteredResponse = response
          let anagraficheResponse: any[] = [];
          if (response.anagrafiche && response.anagrafiche !== null) {
            response.anagrafiche.forEach(response => {
              if (response.nome && element.valore.toUpperCase().includes(response.nome.toUpperCase()) &&
                response.cognome && element.valore.toUpperCase().includes(response.cognome.toUpperCase())) {
                if (element.uri.includes('_') && response.codiceFiscale) {
                  if (element.uri.toUpperCase().includes(response.codiceFiscale.toUpperCase())) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              } else if (response.ragioneSociale && element.valore.toUpperCase().includes(response.ragioneSociale.toUpperCase())) {
                if (element.uri.includes('_') && response.partitaIva) {
                  if (element.uri.toUpperCase().includes(response.partitaIva.toUpperCase())) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              }
            })

          }
          filteredResponse.anagrafiche = anagraficheResponse;
          this.suggerimentiDaRicerca(filteredResponse, element);
          this.creazionePraticaStoreService.setSuggestedSoggettiTerzi(this.suggeritiFound);
          console.log(this.suggeritiFound);
        }));

      } else {
        this.entitiesFiltered.forEach(element => {
          this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore, fromResult: 0 }).subscribe(response => {
            this.suggerimentiDaRicerca(response, null);
            this.creazionePraticaStoreService.setSuggestedSoggettiTerzi(this.suggeritiFound);
          });
        });
      }
    }
  }

  public suggerimentiDaRicerca(response: SearchAnagraficheResponse, entity: any) {
    let categoria;
    let tipoSoggetto;
    this.count = this.count + 1;
    let listaFiltrata: any[] = [];
    if (response && response.anagrafiche) {
      listaFiltrata = response.anagrafiche;
      for (let element of listaFiltrata) {
        if (!element.rimosso) {
          if (entity) {
            if (entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
              //recupera dal valore categoria e tipo
              categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
              tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
            } else {
              categoria = null;
              tipoSoggetto = null;
            }

          }
          let altraparte = new AltraParte();
          altraparte.parte = element;
          let isAssociable = isParteAssociable(element);
          this.suggeritiFound.push({ isAssociable: isAssociable, isAssociated: false, hasDetailsAnagrafica: false, option: altraparte, categoria: categoria !== '-' ? categoria : null, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null });
        }
      }
    }

    if (this.count === this.entitiesFiltered.length) {
      let parti: Parte[] = [];
      this.suggeritiFound.forEach(element => {
        parti.push(element.option.parte);
      });
      this.entitiesFiltered.forEach(entity => {
        const parteExtracted = extractParteEntityFromSearch(this.tipoPersonaOptions, entity, parti);
        if (parteExtracted) {
          if (entity) {
            if (entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
              //recupera dal valore categoria e tipo
              categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
              tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
            } else {
              categoria = null;
              tipoSoggetto = null;
            }

          }
          let altraparte = new AltraParte();
          altraparte.parte = parteExtracted;
          let isAssociable = isParteAssociable(parteExtracted);
          this.suggeritiFound.push({ isAssociable: isAssociable, isAssociated: false, hasDetailsAnagrafica: false, option: altraparte, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null });
        }
      });
    }
    this.checkParteisAltraparte();
  }

  retrieveNewSoggettoTerzo(soggetto: AltraParte) {
    if(!!this.parteTmp) {
      soggetto.parte = this.parteTmp;
    }
    this.altrePartiTmp = soggetto;
    soggetto["cliente"] = false;
    this.salva();
    this.resetSearch();
    // this.parte = null;
    // this.activeTab = 0;
  }

  onParteInsert(parte: Parte) {
    this.parteTmp = parte;
  }

  retrieveAltraParte(soggetto: AltraParte) {
    soggetto["cliente"] = false;
    this.altrePartiTmp = soggetto;
    this.salva();
    this.resetSearch();
  }

  retrieveParte(soggetto: Parte) {
    this.parteTmp = soggetto;
    this.salvaParte(this.parteTmp);
  }  

  resetSearch() {
    this.searchText = null;
    this.foundElements = [];
    if (this.searchElement) {
      this.searchElement.reset();
    }
    this.hasSearched = false;
  }

  public retrieveSearch(response: SearchAnagraficheResponse) {
    this.hasSearched = true;
    let listaFiltrata: any[] = [];
    if (response && response.numeroAnagTotali) {
      this.totalResults = response.numeroAnagTotali;
    } else {
      this.totalResults = 0;
    }
    if (!this.isConcatSearch) {
      this.foundElements = [];
    }
    if (response && response.anagrafiche) {
      listaFiltrata = response.anagrafiche;
      for (let element of listaFiltrata) {
        let altraparte = new AltraParte();
        altraparte.parte = element;
        let isAssociable = isParteAssociable(element);
        this.foundElements.push({ isAssociable: isAssociable, isAssociated: false, hasDetailsAnagrafica: false, option: altraparte });
      }
    }
    this.isConcatSearch = false;
    this.waitResponseSearch = false;
  }

  
  onSearchChange(searchText: string) {
    this.searchText = searchText;
    this.foundElements = [];
    this.isConcatSearch = false;
    this.searchElement.fromResult = 0;
    if (!searchText.trim()) {
      return;
    }
    this.waitResponseSearch = true;
    this.searchElement.manageValue(true);
  }

  reset(): void {
    this.count = 0;
    this.creazionePraticaStoreService.setSoggettiTerzi([]);
    this.creazionePraticaStoreService.save();
    this.altreParti = [];
    // this.suggeritiFound = []
    // this.foundElements = []
    // this.getSuggeriti();
  }

  retrieve(event) {
    if(event.eventType === "modifica") {
      this.salva(event.altraParte, true)
    } else {
      this.salva(event);
    }
  }

  salva(altraParte: AltraParte = null, editMode = false): void {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO);
    let idSezione =
      !!this.accordions[index].properties.fascicolo.idSezioneAltreParti
        ? this.accordions[index].properties.fascicolo.idSezioneAltreParti
        : "new";
    let idFascicolo = this.accordions[index].properties.fascicolo.id;
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    if(altraParte) {
      this.altrePartiTmp = altraParte;
    }

    if(!altraParte && !editMode) {
      this.add(index, idSezione, idFascicolo);
    } else {
      this.update(tipoPratica, tipoFascicolo, idSezione, index, idFascicolo);
    }
  }

  salvaParte(parte:Parte): void {
    const parteIstanza = new Parte();
    Object.assign(parteIstanza, parte);
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO);
    let idFascicolo = this.accordions[index].properties.fascicolo.id;
    if (parte) {
      this.parteTmp = parte;
      this.operations.updateAnagraficaElementParte(parteIstanza).subscribe({
        next: response => {
          if (response) {
            this.readSezione();
            this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
              res => {
                this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
                this.accordions[index].complete = true;
                this.altrePartiTmp = null;
                this.parteTmp = null;
              }
            );
          }
        }
      });    
    }
  }
  

  private update(tipoPratica: any, tipoFascicolo: any, idSezione: any, index: number, idFascicolo: any) {
    this.operations.updateAltraParte(
      this.altrePartiTmp,
      tipoPratica,
      tipoFascicolo,
      idSezione
    ).subscribe(res => {
      this.readSezione();
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.altrePartiTmp = null;
          this.parteTmp = null;
        }
      );
    });
  }

  private add(index: number, idSezione: string, idFascicolo: string) {
    this.operations.addAltraParte(
      this.altrePartiTmp,
      this.accordions[index].properties.urlInsert,
      idSezione,
      idFascicolo
    ).subscribe(res => {
      this.altreParti = res.sezione.altreParti
      this.creazionePraticaStoreService.setSoggettiTerzi(res.sezione.altreParti);
      this.creazionePraticaStoreService.save();
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.readSezione();
          this.altrePartiTmp = null;
          this.parteTmp = null;
        }
      );
    });
  }

  private delete(index: number, idSezione: string, altraparte: AltraParte) {
    this.operations.deleteAltraParte(
      this.accordions[index].properties.urlInsert, 
      idSezione, 
      altraparte.id
    ).subscribe(
      () => {
        this.altreParti = this.altreParti.filter(altraparte => altraparte.parte.id !== altraparte.parte.id)
        this.creazionePraticaStoreService.setSoggettiTerzi(this.altreParti);
        this.creazionePraticaStoreService.save();
        this.readSezione();
      }
    );
  }


  private checkParteisAltraparte() {
    this.suggeritiFound.forEach(element => {
      isAltraparteAssociated(element, this.altreParti)
    });
  }

  readSezione() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneAltreParti || null;
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/altreparti`;
    if(!idSezione) return;
    this.operations.readSezione(url, idSezione).subscribe(response => {
      this.sezione = response.sezione;
      this.fascicolo = this.accordions[index].properties.fascicolo;
      this.altreParti = response.sezione.altreParti;
      this.accordions[index].properties.sezione = response.sezione;
      this.accordions[index].properties.sezione["esn"] = NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO;
      this.creazionePraticaStoreService.onSectionLoaded(response.sezione);
      this.creazionePraticaStoreService.setSoggettiTerzi(this.altreParti);
      this.creazionePraticaStoreService.save();
      this.accordions[index].complete = true;
    });
  }

  onDeleteAltraParte(altraparte: AltraParte) {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO);
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneAltreParti;
    this.delete(index, idSezione, altraparte);
  }

  onDropDownEvent(event: {
    altraParte: AltraParte,
    eventType: 'allegato' | 'disattiva' | 'elimina'
  }) {
    switch (event.eventType) {
      case "elimina":
        let option = {hasDetailsAnagrafica: true, altraParte: event.altraParte}
        this.onDeleteAltraParte(option.altraParte);
        break;
      case "allegato":
        this.attachDocument(event);
        break;
      case "disattiva":
        this.disattivaAltraParte(event.altraParte);
        break;
      default:
        break;
    }
  }

  private attachDocument(event: { altraParte: AltraParte; eventType: 'allegato' | 'disattiva' | 'elimina'; }) {
    this.docAddModalAltreParti.initFormAlternative(
      this.getUrlAddDocToAltraParte(), 
      this.sezione, 
      this.fascicolo.id, 
      false, 
      this.sezione.esn, 
      'Aggiungi documento - Soggetti Terzi', 
      true, 
      event.altraParte
    );
  }


  private disattivaAltraParte(altraParte: AltraParte) {
    let { tipoPratica, tipoFascicolo, idSezione } = this.getProps();
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/altreparti/${idSezione}/altraparte/${altraParte.id}/ritirato`;
    this.operations.disattivaAltraParte(altraParte.id, url, this.sezione.id).subscribe(
      () => this.readSezione()
    );
  }

  private getUrlAddDocToAltraParte() {
    return ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ALTRAPARTE;
  }

  private getProps() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneAltreParti || null;
    return { tipoPratica, tipoFascicolo, idSezione };
  }

  closeModalDocumentAndReadSezione() {
    closeModal('docVersionUpdateModalAltreParti');
    closeModal('docAddModalAltreParti');
    this.readSezione();
  }

  onDocumentEvent(event: {
    documento: DocumentoAllegato,
    altraParte?: AltraParte,
    entityId?: string,
    sezioneId?: string,
    eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
  }) {
    switch (event.eventType) {
      case "elimina":
        this.removeDoc(event.documento, event.entityId);
        break;
      case "metadati":
        this.displayDocUpdateMetadatiModal(event.documento);
        break;
      case "nuova-versione":
        this.showUploadNewVersionModal(event.documento);
        break;
      case "storico":
        this.showHistoryModal(event.documento);
        break;
      default:
        break;
    }
  }

  private removeDoc(documento: DocumentoAllegato, entityId: string) {
    this.operations.removeDocumentoToEntity(documento, this.getUrlRemoveDocFromAltrParte(), entityId)
      .subscribe(() =>{ 
        this.readSezione();
      });
  }

  private showHistoryModal(documento: DocumentoAllegato) {
    this.docVersionHistoryAltreParti.initContentCreazioneRapida(documento, this.fascicolo, 'docVersionHistoryAltreParti');
  }

  private displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    const ref = this.dialog.open(UpdateMetadatiComponent, {
      data: {
        style: { width: "70%"},
        title: 'Modifica metadati',
        documento: documento,
        fascicolo: this.fascicolo,
        tipoPratica: this.fascicolo?.praticaBase.tipoPratica.id
      }
    });
     ref.afterClosed.subscribe(event => {
      if(!event || event.closeEvent) {
        // documento.primary = false;
        return
      };
      if(!!event.response) {
        this.closeModalDocumentAndReadSezione();
      }
    });
  }

  private showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.docVersionUpdateModalAltreParti.initFormCreazioneRapida(documento, 'docVersionUpdateModalAltreParti');
  }

  private getUrlRemoveDocFromAltrParte() {
    return ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ALTRAPARTE;
  }

  reloadSearch() {
    this.searchElement.fromResult = this.foundElements.length;
    this.isConcatSearch = true;
    this.waitResponseSearch = true;
    this.searchElement.manageValue(true);
  }

}
